import React, { useEffect, useRef } from 'react'
import './JSONViewer.less'

const JSONViewer: React.FC<IJSONViewerProps> = (props) => {

  let container = useRef<HTMLDivElement | null>()

  useEffect(() => {
    if (container.current) {
      let json = props.content
      let language = 'json'
      try {
        json = JSON.stringify(JSON.parse(props.content), null, 4)
      } catch {
        language = 'text'
      }
      (window as any).monaco.editor.create(container.current, {
        value: json,
        language: language,
        readOnly: true
      })
    }
  }, [container])

  return (
    <div className="json-viewer" ref={(e) => container.current = e} style={props.style}>

    </div>
  )
}

export interface IJSONViewerProps {
  content: string
  style?: React.CSSProperties
}

export { JSONViewer }